/**
 * MyLighthouse colour tokens — Modern Clinical Premium.
 * Raw palette values live only here. Apps map them to CSS variables and Tailwind.
 *
 * Decisions locked for implementation:
 * 1. Logo HEXs follow brand tokens (#142B49 / #0E6F5C); artwork is adapted to tokens.
 * 2. Dark lockup (with tagline) for marketing/splash; light lockup / symbol for chrome.
 * 3. Visual direction from this brief (Modern Clinical Premium); no external mockup file required.
 * 4. Privacy: NDPA 2023; StackMap Systems = developer credit only; operating entity TBD in legal copy.
 * 5. Semantic colours defined below (not orange).
 * 6. Public US spelling per brief (counseling, color, organization).
 */
export const palette = {
    /** Primary authority — navigation, headings, dark sections */
    midnightNavy: '#142B49',
    /** Primary actions, links, brand emphasis, wordmark "Lighthouse" */
    forestGreen: '#0E6F5C',
    forestGreenHover: '#0B5A4B',
    forestGreenActive: '#094A3E',
    /** Warm editorial / page backgrounds */
    warmCream: '#F8F5EC',
    /** Supporting surfaces, cards */
    paleSage: '#E7F0ED',
    /** Main dashboards, forms */
    softWhite: '#FFFFFF',
    /** Decorative beam accent only — never primary CTA */
    mutedGold: '#C7A76C',
    // Legacy aliases → new roles (do not reintroduce Daylight/Deep Focus/orange)
    daylight: '#F8F5EC',
    sandstone: '#F8F5EC',
    clearCurrent: '#E7F0ED',
    deepFocus: '#0E6F5C',
    deepFocusHover: '#0B5A4B',
    deepFocusActive: '#094A3E',
    midnight: '#142B49',
    clarity: '#FFFFFF',
    slate: '#52616B',
    ink: '#142B49',
    success: '#2F7D4A',
    successSoft: '#E5F4EA',
    warning: '#8B7340',
    warningSoft: '#F7F0E2',
    error: '#9F2D3A',
    errorSoft: '#F8E8EA',
    info: '#142B49',
    infoSoft: '#E7F0ED',
    crisis: '#B42318',
    crisisSoft: '#FEF3F2',
    border: '#DCE5E2',
    borderSubtle: '#E7F0ED',
    textMuted: '#52616B',
    textInverse: '#FFFFFF',
};
/** Fixed crisis disclaimer — use on screening, booking, and help surfaces. */
export const CRISIS_DISCLAIMER = 'MyLighthouse is not an emergency response service. If you or someone else is in immediate danger, contact local emergency services or seek urgent medical assistance.';
//# sourceMappingURL=palette.js.map